module.exports = __webpack_public_path__ + "img/supervivencia1.4b314bbf.webp";